/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import G17Client from '../services/G17Client';
import { GlobalDataStateLoaded } from '../reducers/global-data';
import { DefaultThunk } from '../reducers';
import { RootInitiativeData } from '../types/initiative';

interface LoadInitiativeTreeParams {
  organization: Pick<RootInitiativeData, '_id'>;
  forceRefresh?: boolean;
  blocking?: boolean;
}

export function loadInitiativeTree({
  organization,
  forceRefresh = false,
  blocking = true,
}: LoadInitiativeTreeParams): DefaultThunk {
  return (dispatch, getState) => {
    const initiativeId = organization._id;
    const globalData = getState().globalData;
    if (!forceRefresh && (globalData.initiativeId === initiativeId || globalData.loading)) {
      return;
    }

    if (blocking) {
      dispatch({ type: actionTypes.LOADING_GLOBALDATA, initiativeId, organization });
    }

    G17Client.get(`initiative-tree/companies/${initiativeId}?extended=true`)
      .then((response) => {
        const data = response.data.data;
        return dispatch({
          type: actionTypes.LOADED_GLOBALDATA,
          organization: data.root,
          data: {
            initiativeTree: data.tree,
            organization: data.root,
            config: data.config,
            companyAgreementsRequired: data.companyAgreementsRequired,
            appConfig: data.appConfig,
          } as GlobalDataStateLoaded['data'],
        });
      })
      .catch((e) => {
        dispatch({
          type: actionTypes.ERROR_GLOBALDATA,
          error: e.response,
        });
      });
  };
}

export function reloadInitiativeTree(): DefaultThunk {
  return (dispatch, getState) => {
    const globalData = getState().globalData;
    const organization = globalData.organization;
    if (!organization) {
      return;
    }
    dispatch(
      loadInitiativeTree({
        organization,
        forceRefresh: true,
        blocking: true,
      }),
    );
  };
}
